(function(){
	profilePicService.$inject = ['SUGUtilities'];
	function profilePicService(SUGUtilities){
		var svc = {};
		
		svc.parseProfilePicData = function( data ){
			if ( typeof data === 'object' ){
				// fix object keys to lowercase
				var dataObject = {};
				for ( var key in data ){
                    if (data.hasOwnProperty(key)){
                        var lckey = key.toLowerCase();
                        dataObject[lckey] = data[key];

                        // check if we have proper nouns that were converted to booleans by poor serialization
                        // this is accounted for in a similar way in the coldfusion code profilePicService.cfc parseProfilePicData()
                        // i.e. user's first/last name is "No Yes", initials should come out as "NY"
                        if( ['displayfirstname','displaylastname','firstname','lastname'].indexOf(lckey) >= 0 && SUGUtilities.isBoolean(data[lckey])){
                            if(!data[lckey]){
                                data[lckey] = "No";
                            } else {
                                data[lckey] = "Yes";
                            }
                        }
                    }
				}

				if ( "profilepicdata" in dataObject && dataObject.profilepicdata.length ){
					return dataObject.profilepicdata;
				}
				
				if ( "displayfirstname" in dataObject && "displaylastname" in dataObject && dataObject.displayfirstname.length && dataObject.displaylastname.length ){
					var initials = dataObject.displayfirstname.substr(0,1).toUpperCase() + dataObject.displaylastname.substr(0,1).toUpperCase();
				} else
				if ( "firstname" in dataObject && "lastname" in dataObject && dataObject.firstname.length && dataObject.lastname.length ){
					var initials = dataObject.firstname.substr(0,1).toUpperCase() + dataObject.lastname.substr(0,1).toUpperCase();
				}
				if ( initials ){
					var profilepicdata = {};
					profilepicdata['id'] = 1;
					profilepicdata['type'] = 'initials';
					profilepicdata['value'] = initials;
					return profilepicdata;
				}
			}
			return { "id" : "2", "type" : "portrait", "value" : "0" };
		}
		
		return svc;
	}

    angular.module('SUGApp').factory('profilePicService',profilePicService);//register factory with AngularJS

}());